/*
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import { Box } from '@mui/material';
import React from 'react';
import { Route, Switch } from 'react-router';
import { useRouteMatch } from 'react-router-dom';
import RolesTable from './RolesTable';
import RolesForm from './RolesForm';

export const GLOBAL_SCOPE = 'GLOBAL SCOPE';

const Roles = () => {
  const { path } = useRouteMatch();
  return (
    <Box display="flex" flexDirection="column" height={'100%'} gap={'8px'}>
      <Switch>
        <Route path={path} exact>
          <RolesTable />
        </Route>
        <Route path={`${path}/new`}>
          <RolesForm />
        </Route>
        <Route path={`${path}/edit/:uuid`}>
          <RolesForm />
        </Route>
      </Switch>
    </Box>
  );
};

export default Roles;
